const storage = localStorage.getItem('devs');
const customServer = storage && storage === '47' ? 'https://online47.bellmeet.com/' : storage;
const envServer = process.env.NODE_ENV !== "production" ? 'https://localhost:3000/' : 'https://online.bellmeet.com/';
const apiConfig = {
	BASE_URL : storage ? customServer : envServer
}
export default apiConfig